import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import i18next from 'i18next';

export const LOADING_INTERVAL_IN_MS = 300;

/**
 * LoadingText component displays an animated "Loading..." text that updates periodically.
 */
export const LoadingText = () => {
  const [loadingText, setLoadingText] = useState(i18next.t('Loading'));
  const loadingInterval = useRef(null);

  const updateText = useCallback(() => {
    setLoadingText((prevLoadingText) => {
      if (prevLoadingText.length === 10) {
        return i18next.t('Loading');
      }

      return `${prevLoadingText}.`;
    });
  }, []);

  useEffect(() => {
    loadingInterval.current = setInterval(updateText, LOADING_INTERVAL_IN_MS);

    return () => {
      clearInterval(loadingInterval.current);
    };
  }, []);

  return (
    <span
      className="fs-italic f3 f5-l"
      data-testid="loading-text"
    >
      {loadingText}
    </span>
  );
};
